import React from 'react';
import { mixed, object, string } from 'yup';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Form, { Botao as BotaoForm, Campo, DropZone } from 'Component/Form';
import Modal from 'Component/Modal';
import Legenda from 'Interface/Legendas';
import { LEGENDAS } from 'View/constants';
import {
  useEditarLegendaMutation,
  useRecuperarLegendaQuery,
} from 'View/Service/Default/Legendas';

interface Props {
  exibir: boolean;
  legendaId: number;
  aoFechar: (estado: boolean) => void;
}

const regras = object({
  nome: string().required('Obrigatório'),
  codigo: string()
    .min(2, 'Deve conter somente 2 caracteres')
    .max(2, 'Deve conter somente 2 caracteres')
    .required('Obrigatório'),
  url: mixed()
    .test('tipo', 'Formato não suportado', (valor) => {
      if (valor && valor.type) {
        return LEGENDAS.includes(valor.type);
      }

      return true;
    })
    .required('Obrigatório'),
});

const Editar = ({ exibir, aoFechar, legendaId }: Props): React.ReactElement => {
  const toast = useToast();

  const [editarLegenda] = useEditarLegendaMutation();

  const { data: { legenda } = {} } = useRecuperarLegendaQuery({
    id: legendaId,
    contain: ['UnidadesDeAprendizagem'],
  });

  const editar = async (dados: Legenda): Promise<void> => {
    try {
      await editarLegenda(dados).unwrap();

      toast({ conteudo: 'Editado com sucesso!', tema: 'success' });

      aoFechar(false);
    } catch (erro) {
      toast({
        titulo: 'Erro ao editar',
        conteudo: 'Verifique os logs para maiores detalhes.',
        tema: 'danger',
      });
    }
  };

  return (
    <Modal exibir={exibir} aoFechar={aoFechar}>
      <Form onSubmit={editar} inicial={legenda} regras={regras}>
        <Campo name="nome" rotulo="Nome da lingua" />
        <Campo name="codigo" rotulo="Código de dois digitos para a linguagem" />
        <DropZone
          name="url"
          ajuda="O arquivo de legenda deve ser no formato para VTT."
          path={`unidade-de-aprendizagem/${legenda?.unidade_de_aprendizagem?.titulo.slug()}`}
        />
        <div className="d-flex gap-2">
          <BotaoForm>Salvar</BotaoForm>
          <Botao onClick={() => aoFechar(false)} tema="light">
            Cancelar
          </Botao>
        </div>
      </Form>
    </Modal>
  );
};

export default Editar;
